/*
  Here are the various URL environment variables that are used throughout the app.

  ## CURRENT ENVS:
  #### Vercel:
  VITE_AUDIENCE_BASE_URL: Set this once in Vercel to configure both Auth0 and the API.

  #### Dev:
  VITE_API_BASE_URL: The base URL for the API. (used only for local development since Auth0 won't allow localhost as a valid audience setting)

  ## LEGACY ENVS:
  #### Vercel:
  VITE_API_AUDIENCE: Legacy ENV used on Vercel to configure Auth0 and the API.
  VITE_GRAPHQL_ENDPOINT: Legacy ENV used on Vercel and locally to configure the GraphQL endpoint.

  #### Dev:
  VITE_API_URL: The base URL for the API. (used only for local development)
*/

const apiAudiencePath = '/api/v1';
const apiBasePath = '/studio/v1';
const apiGraphqlPath = `${apiBasePath}/graphql`;

// If VITE_AUDIENCE_BASE_URL is set, use it to construct the audience URL.
// Otherwise, look for the legacy variable VITE_API_AUDIENCE.
export const apiAudienceUrl = import.meta.env.VITE_AUDIENCE_BASE_URL
  ? `${import.meta.env.VITE_AUDIENCE_BASE_URL}${apiAudiencePath}`
  : import.meta.env.VITE_API_AUDIENCE;

// If VITE_API_BASE_URL is set, use it to construct the base URL. (used mainly for local development)
// Otherwise, if VITE_AUDIENCE_BASE_URL is set, use that.
// Finally, look for the legacy variables VITE_API_URL or VITE_API_AUDIENCE.
export const apiUrl = import.meta.env.VITE_API_BASE_URL
  ? `${import.meta.env.VITE_API_BASE_URL}${apiBasePath}`
  : import.meta.env.VITE_AUDIENCE_BASE_URL
    ? `${import.meta.env.VITE_AUDIENCE_BASE_URL}${apiBasePath}`
    : import.meta.env.VITE_API_URL || import.meta.env.VITE_API_AUDIENCE;

// If VITE_API_BASE_URL is set, use it to construct the base URL. (used mainly for local development)
// Otherwise, if VITE_AUDIENCE_BASE_URL is set, use that.
// Finally, look for the legacy variable VITE_GRAPHQL_ENDPOINT.
export const apiGraphqlUrl = import.meta.env.VITE_API_BASE_URL
  ? `${import.meta.env.VITE_API_BASE_URL}${apiGraphqlPath}`
  : import.meta.env.VITE_AUDIENCE_BASE_URL
    ? `${import.meta.env.VITE_AUDIENCE_BASE_URL}${apiGraphqlPath}`
    : import.meta.env.VITE_GRAPHQL_ENDPOINT;

// The backend mounts the public signup route only when the deployment's
// ENABLE_SIGNUP is "true"; vite.config.mts exposes that same key so the
// frontend route can gate itself from the one setting.
export const signupEnabled = import.meta.env.ENABLE_SIGNUP === 'true';
